
function GridItem(props){
    const {data} = props;
    console.log(data)
    let allow_booking = false;
    let image_srcset = data.image_data.toString();

    if (data.performances && !data.enable_priority_booking){
      allow_booking = true
    }
    return (
        <>
          <a href={data.url} className="slot">
            <div className="slot-content">

                <div className="slot-content-left " >
                    {data.title &&
                        <h3 className="slot-title font-title font-uppercase font-transparent step-4" dangerouslySetInnerHTML={{ __html: data.title }}/>
                    }
                    {data.text &&
                        <div className="slot-text te">{data.text}</div>
                    }
                    </div>
                {(data.secondary_title && data.secondary_text)  &&
                  <div class={"slot-content-right"}>
                  {data.secondary_title &&
                      <h3 className="slot-content-right-title font-title font-transparent font-uppercase step-4" dangerouslySetInnerHTML={{ __html: data.secondary_title }}/>
                  }
                  {data.secondary_text &&
                      <div className="slot-text slot-content-right-text te">{data.secondary_text}</div>
                  }
                  </div>

                }


            </div>
            {data.image_url &&
                <div className="slot-image">
                    <div className="image-container">
                        <img
                          srcset={image_srcset}
                          src={data.image_url}
                          alt={data.image_alt} 
                          sizes="(min-width: 1040px) 63.16vw, 84.03vw" />
                        {data.slot_tags &&
                          <div class="tags"> {

                            data.slot_tags.map(tag =>
                              <div className="tag">{tag.name}</div>
                            )
                          }

                           </div>
                        }

                    </div>
                </div>
            }
          </a>
        </>
    )
}

export default GridItem;
